/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
// import Icon from 'components/icon';
import React, { useState } from 'react';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { currencyFormat } from 'helpers/utils';
import { useAlert } from 'providers/AlertModalProvider';
import postData from 'services/postData';
import PinInput from 'react-pin-input';
import { useEffect, useRef } from 'react';
import PageLoader from 'components/custom/animate-component/PageLoader';
import apiEndpoints from 'constants/apiEndpoints';
import PaymentPinModal from 'views/payment/quick-payment/PaymentPinModal';
import { useSearchParams } from 'react-router-dom';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    margin-left: auto;
    max-width: 800px; /* Increase this value as needed */
    width: 100%; /* Optional: ensures full width usage */
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;
function AmountModal({ show, handleClose, data, refreshData, closeMianModal }) {
  const userDataJson = window.localStorage.getItem('kerpUserData2.1');
  const parsedUserData = JSON.parse(userDataJson || '{}');
  const [loading, setLoading] = useState(false);
  const [pinRef, setPinRef] = useState(false);
  const [pin, setPin] = useState('');
  const [isPinCorrect, setIsPinCorrect] = useState(true);
  const { showAlert } = useAlert();
  const inputRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showPin, setShowPin] = useState('');
  const [payMode, setPayMode] = useState('');
  const amount = data.final_amount;

  const netPayableAmount = Math.round(amount);
  const roundOffAmount = (netPayableAmount - amount).toFixed(2);
  const signedRoundOffAmount =
    roundOffAmount > 0 ? `${roundOffAmount}` : `${roundOffAmount}`;
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const { handleChange, handleBlur, values, errors, touched, handleSubmit } =
    useFormik({
      initialValues: {
        amount: Number(data.final_amount) || 0,
        paymentMode: 'neft'
      },
      validationSchema: Yup.object({
        amount: Yup.number('Must be a number')
          .required('Please provide amount')

          .min(0, 'Amount must be at least 0'),
        paymentMode: Yup.string().required('Please select payment mode')
      }),

      onSubmit: values => {
        handleOnSubmit(values);
      }
    });

  const handleOnSubmit = async ({ pin, latitude, longitude }, callback) => {
    setLoading(true);
    let requestStatus;
    console.log('🚀 ~ handleOnSubmit ~ parsedUserData:', parsedUserData);

    if (data.retrieve === 'retrieve') {
      requestStatus = await postData(
        {
          paid_by: parsedUserData.user_id,
          mode: values.paymentMode,
          settelment_id: data?.settel_id,
          transaction_pin: pin
        },
        apiEndpoints.truckerPayment.truckerRetrievePayment
      );
    } else {
      console.log('🚀 ~ handleOnSubmit ~ parsedUserData:', parsedUserData);

      requestStatus = await postData(
        {
          paid_by: parsedUserData.user_id,
          mode: values.paymentMode,
          payable_amount: Number(data?.final_amount)?.toFixed(2),
          bank_account_number: data?.truckerInformation?.bankAccountNo,
          bank_ifsc: data?.truckerInformation?.ifscCode,
          beneficiary_name:
            data?.truckerInformation?.trucker_account_holder_name,
          settelment_no: data?.settelment_no,
          settelment_id: data?.settel_id,
          trucker_id: data?.trucker_id,
          transaction_pin: pin,
          round_off_amount: signedRoundOffAmount,
          net_final_payment_amount: netPayableAmount,
          latitude: latitude,
          longitude: longitude
        },
        apiEndpoints.truckerPayment.truckerPaymentPay
      );
    }

    callback(requestStatus);
    if (requestStatus.status) {
      setLoading(false);
      handleClose();
      closeMianModal(false);
      refreshData();
      showAlert({
        variant: 'success',
        message: `The ${data.retrieve === 'retrieve' ? 'Retrieve Payment' : 'Payment'}  of ${currencyFormat(netPayableAmount)} to the Trucker ${
          data?.truckerInformation?.truckerName
        }  was successful.`
      });
    } else {
      if (requestStatus.message === 'Invalid transaction PIN') {
        setIsPinCorrect(false);
        pinRef?.clear();
        setPin('');
        setLoading(false);
      } else {
        setLoading(false);
        showAlert({
          variant: 'danger',
          message: `Failed to ${data.retrieve === 'retrieve' ? 'Retrieve Payment' : 'Pay'}: ${requestStatus.message}`
        });
      }
    }
  };

  const handleParams = type => {
    if (type === 'add') {
      searchParams.set('pinModal', 'open');

      // Update the browser URL without reloading the page
      setSearchParams(searchParams);
    } else if (type === 'remove') {
      searchParams.delete('pinModal');
      // Update the browser URL without reloading the page
      setSearchParams(searchParams);
    }
  };
  const handlePinModal = mode => {
    setPayMode(mode);
    handleParams('add');
    setShowPin(true);
  };
  const handleChangePin = val => {
    setPin(val);
    if (!isPinCorrect) {
      setIsPinCorrect(true);
    }
  };
  const handleClosePinModal = () => {
    setShowPin(false);
    setPayMode('');
    handleParams('remove');
  };
  return (
    <>
      <CustomModal show={show} onHide={() => {}} backdrop="static" centered>
        <div className="">
          <div className="card border-0 rounded">
            <div className="card-body px-4 py-4">
              <h5 className="fw-semibold mb-1">
                <i className="bi bi-credit-card-2-back" /> Settlement Payment
              </h5>
              <p className="text-secondary mb-4">
                Complete your settlement transaction
              </p>
              {/* Top Information */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <h6 className="text-muted fw-semibold mb-1">
                    Settlement Number
                  </h6>
                  <div className="fw-bold text-dark">{data.settelment_no}</div>
                </div>
                <div className="col-md-6 text-md-end">
                  <h6 className="text-muted fw-semibold mb-1">Payment To</h6>
                  <div className="fw-bold text-dark">
                    {data.truckerInformation.truckerName}
                  </div>
                </div>
              </div>
              {/* Payment Details Section */}
              <ul
                className="nav nav-tabs d-md-none mb-3"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="bank-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#bank"
                    type="button"
                    role="tab"
                  >
                    Bank Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="summary-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#summary"
                    type="button"
                    role="tab"
                  >
                    Payment Summary
                  </button>
                </li>
              </ul>
              <div className="row">
                {/* Tabs for mobile */}
                <div className="tab-content d-md-none" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="bank"
                    role="tabpanel"
                  >
                    <div className="card mb-3 border rounded shadow-sm">
                      <div className="card-body">
                        <h6 className="fw-semibold mb-3">Bank Details</h6>
                        <p className="mb-2">
                          <span className="fw-semibold text-muted fs-9">
                            Beneficiary Name
                          </span>
                          <br />
                          {data.truckerInformation.trucker_account_holder_name}
                        </p>
                        <p className="mb-2">
                          <span className="fw-semibold text-muted fs-9">
                            Account Number
                          </span>
                          <br />
                          {data.truckerInformation.bankAccountNo}
                        </p>
                        <p className="mb-2">
                          <span className="fw-semibold text-muted fs-9">
                            Bank Name
                          </span>
                          <br />
                          {data.truckerInformation.bankName}
                        </p>
                        <p className="mb-0">
                          <span className="fw-semibold text-muted fs-9">
                            IFSC Code
                          </span>
                          <br />
                          {data.truckerInformation.ifscCode}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="summary" role="tabpanel">
                    <div className="card mb-3 border rounded shadow-sm">
                      <div className="card-body">
                        <h6 className="fw-semibold mb-3">Payment Summary</h6>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted fs-9">Base Amount</span>
                          <span>₹10,000.75</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted fs-9">
                            Round off Amount
                          </span>
                          <span className="text-success">+ ₹0.25</span>
                        </div>
                        <div className="d-flex justify-content-between border-top pt-2 fw-bold">
                          <span>Final Amount</span>
                          <span>₹10,001.00</span>
                        </div>
                        <div className="mt-3">
                          {/* <label className="form-label mb-1 fw-semibold">
                          
                        </label> */}
                          <span className="text-muted fs-9 mb-1">
                            Payment Mode
                          </span>

                          <select className="form-select form-select-sm w-50">
                            <option selected="">NEFT</option>
                            <option>RTGS</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Side-by-side layout for md+ */}
                <div className="col-md-6 d-none d-md-block">
                  <div className="card border rounded shadow-sm mb-3">
                    <div className="card-body">
                      <h6 className="fw-semibold mb-3">Bank Details</h6>
                      <p className="mb-2">
                        <span className=" text-muted fs-9">
                          Beneficiary Name
                        </span>
                        <br />
                        <span className="fw-semibold">
                          {data.truckerInformation.trucker_account_holder_name}
                        </span>
                      </p>
                      <p className="mb-2">
                        <span className=" text-muted fs-9">Account Number</span>
                        <br />
                        <span className="fw-semibold">
                          {data.truckerInformation.bankAccountNo}
                        </span>
                      </p>
                      <p className="mb-2">
                        <span className=" text-muted fs-9">Bank Name</span>
                        <br />
                        <span className="fw-semibold">
                          {data.truckerInformation.bankName}
                        </span>
                      </p>
                      <p className="mb-0">
                        <span className=" text-muted fs-9">IFSC Code</span>
                        <br />
                        <span className="fw-semibold">
                          {data.truckerInformation.ifscCode}{' '}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-none d-md-block">
                  <div className="card border rounded shadow-sm mb-3">
                    <div className="card-body">
                      <h6 className="fw-semibold mb-3">Payment Summary</h6>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted fs-9">Base Amount</span>
                        <span>₹{amount}</span>
                      </div>
                      <div className="d-flex justify-content-between border-top mb-3 pt-3">
                        <span className="text-muted fs-9">
                          Round off Amount
                        </span>
                        <span className="text-success">
                          {' '}
                          {signedRoundOffAmount > 0 ? '+' : ''}
                          {signedRoundOffAmount}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between border-top pt-3 fw-bold">
                        <span>Final Amount</span>
                        <span>₹{netPayableAmount}</span>
                      </div>
                      <div className="mt-4">
                        {/* <span className="text-muted fs-9"> Payment Mode</span> */}

                        {/* <select className="form-select form-select-sm w-50">
                        <option selected="">NEFT</option>
                        <option>RTGS</option>
                      </select> */}
                        <Form.Group controlId="paymentMode">
                          {/* <Form.Label className="ps-1">
                          Select Payment Mode
                        </Form.Label> */}
                          <span className="text-muted fs-9"> Payment Mode</span>

                          <Form.Select
                            value={values.paymentMode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.paymentMode && errors.paymentMode
                            }
                            style={{ width: '295px' }}
                            size="sm"
                          >
                            <option value="">Select</option>

                            {/* Always show NEFT */}
                            <option value="neft">NEFT</option>

                            {/* Show RTGS only when amount > 500000 */}
                            {values.amount > 500000 && (
                              <option value="rtgs">RTGS</option>
                            )}
                          </Form.Select>

                          <Form.Control.Feedback
                            className="d-inline fs-10"
                            type="invalid"
                          >
                            {errors.paymentMode}
                          </Form.Control.Feedback>

                          {/* Show warning when amount > 500000 */}
                          {values.amount > 500000 && (
                            <p className="fs-10 ms-1 mt-1 mb-0 text-warning">
                              For amounts above ₹5,00,000, both NEFT and RTGS
                              are allowed.
                            </p>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="text-center">
                <Form.Label className="ps-1">Insert Payment Pin</Form.Label>
                <PinInput
                  inputFocusStyle={{
                    outline: 0,
                    borderWidth: '2px',
                    padding: ' 0.05rem',
                    borderColor: '#004DFF'
                  }}
                  inputStyle={{
                    borderWidth: '1px',
                    lineHeight: '1.5',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    borderStyle: 'solid',
                    letterSpacing: '0.15px',
                    padding: '0.05rem',
                    backgroundColor: 'transparent',
                    fontFamily:
                      'Inter, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                    borderColor: '#757575',
                    WebkitTransition:
                      'border-color 300ms cubic-bezier(0.4, 0q 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    transition:
                      'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    maxWidth: '40px',
                    textAlign: 'center',
                    height: '40px'
                   
                  }}
                  length={4}
                  focus
                  className="text-white mx-auto"
                  ref={p => setPinRef(p)}
                  type="numeric"
                  onChange={handleChangePin}
                />
                {!isPinCorrect ? (
                  <small className="text-danger">Incorrect Pin</small>
                ) : null}
              </div> */}
              <div className="row mt-4">
                <div className="col-6 pe-2">
                  <Button
                    className="border w-100"
                    disabled={loading}
                    onClick={handleClose}
                    variant="outline-secondary"
                  >
                    Cancel
                  </Button>
                </div>
                <div className="col-6 ps-2">
                  <Button
                    className="w-100"
                    variant={'warning'}
                    // disabled={true}
                    onClick={() => handlePinModal(values.paymentMode)}
                  >
                    <i className="bi bi-check-circle-fill me-1" /> Pay
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <PageLoader loading={loading} loadingMessage={'Pay via cash'} />
      </CustomModal>
      <PaymentPinModal
        resetData={'resetData'}
        isDifferentName={false}
        proceedPayment={handleOnSubmit}
        show={showPin}
        amount={netPayableAmount}
        receiverName={data?.truckerInformation.truckerName}
        driverName={data?.truckerInformation.truckerName}
        handleClose={handleClosePinModal}
        paymentMode={payMode.toLocaleUpperCase()}
        paymentCallback={() => {
          handleClose();
          refreshData();
        }}
      />
    </>
  );
}

export default AmountModal;
